theme.waitForElement('body.swiper--enabled').then(() => {
  const productCarouselTiles = new theme.vendor.Swiper(".product-carousel-slides", {
    speed: 400,
    slidesPerView: "auto",
    spaceBetween: 20,
    centeredSlides: !1,
    loop: !0,
    keyboard: {
      enabled: !0,
      onlyInViewport: !0
    }
  });
});